import { PALETTE } from '../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        root: {
            backgroundColor: PALETTE.Secondary,
            width: '100%',
            height: '50px',
            color: PALETTE.Header.TextColor,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px'
        },
        subHeaderIcon:{
            fill: "#FFF"
        },
        title: {
            paddingLeft: '10px',
            fontWeight: 600
        }
    }
}